import React, { useEffect, useMemo } from 'react';
import '../scss/button.scss';
import { ReactComponent as StarfinLogo } from '../images/stashfin-logo.svg'
import { ReactComponent as ShieldIcon } from '../images/shield-icon.svg'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import SelectDropdown from '../components/SelectDropdown';
import { useGetAggregatorBankListMutation, useUpdateOccupationMutation } from '../lib/services/bankApi';
import { useDispatch, useSelector } from 'react-redux';
import { setBankList, setConsentData, setError, setIsSalaried, setPerfiosUrl, setSelectedBank } from '../lib/features/bankSlice';
import { generateChecksum } from '../lib/middleware/generateChecksum';
import PageHeader from '../components/PageHeader';
import { useTapClickMutation } from '../lib/middleware/TapClickApi';
import { pushCleverTapEvent } from "../lib/middleware/CtEvents";


function Occupation() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { selectedBank, error, bankList, isSalaried, perfios_url } = useSelector((state) => state.bank);
    const [getAggregatorBankList] = useGetAggregatorBankListMutation();
    const [updateOccupation, {isLoading}] = useUpdateOccupationMutation();
    const [tapClick] = useTapClickMutation()
    const location = useLocation()
    const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search])
    const jwt = useMemo(() => queryParams.get('jwt_token'), [queryParams])
    const secret = useMemo(() => queryParams.get('secret'), [queryParams])
    useEffect(() => {
        const fetchBankList = async () => {
            try {
                const device_id = localStorage.getItem('code') || ''
                const bodyData = {
                    mode: 'account-aggregator-bank-list',
                    device_id,
                }
                const checksum = generateChecksum(bodyData)
                let jwt_token
                if (jwt) {
                    jwt_token = jwt
                    localStorage.setItem('jwt', jwt)
                } else {
                    jwt_token = localStorage.getItem('jwt')
                }
                const scrt = secret ? secret : localStorage.getItem('secret')
                const response = await getAggregatorBankList({ checksum, jwt_token, scrt, device_id }).unwrap()
                if (response && (response.status === 'success' || response.status === true)) {
                    if (response.results && response.results.fip) {
                        dispatch(setBankList([...response.results.fip].sort((a, b) => a.name.localeCompare(b.name))));
                        dispatch(setPerfiosUrl(response.results.perfios_url))
                    }
                    /*if (response && response.redirect_url) {
                        dispatch(setRedirection(response.redirect_url))
                    }*/
                } else if ((response.data && response.data.status === 'error') || (response && response.status === 'error')) {
                    if ((response.data && response.data.message && response.data.message === 'Login expired! Please re-login.') || (response.message && response.message === 'Login expired! Please re-login.')) {
                        localStorage.removeItem('jwt');
                        localStorage.removeItem('lastVisitedPage');
                        const phone = localStorage.getItem('phone')
                        localStorage.clear()
                        phone ? navigate(`/?phone=${phone}`) : navigate('/');
                        
                    } else {
                        dispatch(setError(response.data.message))
                    }
                } else if (response.data && response.data.message === 'Login expired! Please re-login.') {
                    localStorage.removeItem('jwt');
                    localStorage.removeItem('lastVisitedPage');
                    const phone = localStorage.getItem('phone')
                    localStorage.clear()
                    phone ? navigate(`/?phone=${phone}`) : navigate('/');
                    
                } else if (response.error) {
                    if (response.error && response.error.data && response.error.data.message) {
                        dispatch(setError(response.error.data.message))
                    } else {
                        dispatch(setError('Please check your internet or try again later.'))
                    }
                } else if (response && response.status === 'error') {
                    dispatch(setError(response.message))
                }
            } catch (error) {
                dispatch(setError('Something went wrong. Please try again later.'));
            }
        }
        fetchBankList()
    }, [getAggregatorBankList, dispatch, navigate, jwt, secret])
    const handleSubmit = async () => {
        if (!isSalaried) {
            dispatch(setError('Please select occupation.'));
        } else if (!selectedBank) {
            dispatch(setError('Please select a bank.'));
        } else {
            try {
                const device_id = localStorage.getItem('code') || ''
                let jwt_token
                if (jwt) {
                    jwt_token = jwt
                    localStorage.setItem('jwt', jwt)
                } else {
                    jwt_token = localStorage.getItem('jwt')
                }
                const scrt = secret ? secret : localStorage.getItem('secret')
                const checksum = await generateChecksum({ occupation: isSalaried, mode: 'submit_occupation', fip_ids: selectedBank.id, device_id })
                const result = await updateOccupation({ jwt_token, scrt, occupation: isSalaried, checksum, fip_ids: selectedBank.id, device_id })
                if ((result.data && (result.data.status === 'error' || result.data.status === false)) || (result && result.status === 'error')) {
                    debugger;
                    dispatch(setError(result.data.message || result.data.errors || 'Some error occured. Please try again.'))
                    if (result.data.message === 'Login expired! Please re-login.') {
                        localStorage.removeItem('jwt');
                        localStorage.removeItem('lastVisitedPage');
                        const phone = localStorage.getItem('phone')
                        localStorage.clear()
                        phone ? navigate(`/?phone=${phone}`) : navigate('/');
                        
                    }
                } else if (result.data && result.data.http_code === 201) {
                    if (result.data.message === 'Login expired! Please re-login.') {
                        dispatch(setError(result.data.message))
                        localStorage.removeItem('jwt');
                        localStorage.removeItem('lastVisitedPage');
                        const phone = localStorage.getItem('phone')
                        localStorage.clear()
                        phone ? navigate(`/?phone=${phone}`) : navigate('/');
                        
                    } else {
                        dispatch(setError(result.data.message))
                    }
                }
                else if (result.error) {
                    debugger;
                    dispatch(setError(result.error.error || 'Please check your internet or try again later.'))
                } else {
                    const event_name = 'web_bank_statment_upload'
                    const event_property = { Source: window.localStorage.getItem('utm_source'), segment: result.data.customer_segmentation }
                    await pushCleverTapEvent({ event_name, event_property })
                    if (result && result.data && result.data.status && result.data.results.status === 'INITIATED') {
                        debugger;
                        dispatch(setConsentData({
                            fip_ids: result.data.results.fip_ids,
                            mobile_number: result.data.results.mobile_number,
                            organisation_id: result.data.results.organisation_id,
                            reference_id: result.data.results.reference_id,
                            tracking_id: result.data.results.tracking_id,
                            data_details: result.data.results.data_details,
                            vua_id: result.data.results.vua_id,
                            account_aggregator_id: result.data.results.account_aggregator_id,
                            return_url: result.data.results.return_url
                        }))
                        // navigate('/consent')
                        debugger;
                        window.location.href = result.data.redirect_url
                    } else {
                        debugger;
                        window.location.href = result.data.redirect_url
                    }
                }
            } catch (error) {
                dispatch(setError('Something went wrong. Please try again later.'));
            }
        }
    }
    return (
        <div className='external-wrapper verify-bank retrive-statement statement-page'>
            <div className='page-content'>
                <PageHeader />
                <div className='page-heading'>
                    <h2 className='page-title'>Share Bank Statement</h2>
                    <p>Securely fetch your bank statements for quick account verification </p>
                </div>
                <div className='verify-content'>
                    {error && <div className="error ps-0 pb-2">{error}</div>}
                    <div className="radio-wrapper">
                        <label className='radio-label'>Your Occupation Type</label>
                        <div className='radios'>
                            <div className='radio'>
                                <input
                                    type="radio"
                                    name="salaried"
                                    value="salaried"
                                    id='salaried'
                                    checked={isSalaried === 'salaried'}
                                    onChange={() => dispatch(setIsSalaried('salaried'))}
                                />{' '}
                                <label htmlFor='salaried'>Salaried</label>
                            </div>
                            <div className='radio'>
                                <input
                                    type="radio"
                                    name="salaried"
                                    value="self employed"
                                    id="selfEmployed"
                                    checked={isSalaried === 'self employed'}
                                    onChange={() => dispatch(setIsSalaried('self employed'))}
                                    className="ms-3"
                                />{' '}
                                <label htmlFor='selfEmployed'>Self-Employed</label>
                            </div>
                        </div>
                    </div>
                    {isSalaried ? <div className='input-wrapper mb-0'><SelectDropdown
                        name="retriveBank" id="bankControl"
                        options={bankList}
                        labelText={isSalaried && isSalaried === 'salaried' ? 'Select salary bank account' : 'Select primary bank account'}
                        value={selectedBank ? selectedBank.name : ''}
                        onChange={(option) => {
                            dispatch(setSelectedBank(option))
                            dispatch(setError(''))
                        }}
                    />
                        <p className='dark-font'>Your loan will be disbursed to your selected bank account</p>
                        {/* <p className='text-center mb-0'><Link to={perfios_url} style={{ textDecoration: 'underline' }}>Click here if your bank is not listed</Link></p> */}
                        </div> : null}
                </div>
                <div className='bottom-footer ps-0 pe-0'>
                    <p className='secure-text'><ShieldIcon /> 100% Safe & secured</p>
                    <p className='powered-by'>Powered by <StarfinLogo /></p>
                    <button type="button" className={`btn btn-primary ${isSalaried === null || isLoading ? 'disabled' : ''}`} onClick={handleSubmit}>Continue</button>
                </div>
            </div>
        </div>
    );
}

export default Occupation;
